<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-10-08 09:46:38
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-10-18 17:24:14
 * @FilePath: /streamline_detail/src/views/home/components/newProductBaseInfo/superInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div
    :style="{
      backgroundImage: `url(${$setPicSize(
        isVipMemeber
          ? 'https://pic4.zhuanstatic.com/zhuanzh/35ef20ff-fe69-4419-8c2b-d613b1f6a2ad.png'
          : 'https://pic6.zhuanstatic.com/zhuanzh/d86e48a6-9197-450e-bbef-9bbcd2b77377.png',
        690,
        200
      )})`
    }"
    class="super-wrapper"
  >
    <!-- 十亿补贴 -->
    <div v-if="billionLevel && !superLevel" class="super-wrapper__header">
      <div class="text-wrapper">
        <img
          src="https://pic2.zhuanstatic.com/zhuanzh/3260bd6e-fa4a-4b55-a91f-ab59eea0480d.png"
          alt=""
        />

        <span class="title">十亿补贴</span>
      </div>
      <div class="billion-text">
        <span class="text">官方补贴</span>
        <span class="dot">·</span>
        <span class="text">正品保障</span>
      </div>
    </div>
    <div v-else class="super-wrapper__header">
      <div class="text-wrapper">
        <img
          src="https://pic2.zhuanstatic.com/zhuanzh/3260bd6e-fa4a-4b55-a91f-ab59eea0480d.png"
          alt=""
        />

        <span class="title">{{ dataInfo.couponLv.showTitle }}</span>
      </div>
      <div class="seckill">
        <seckill-component
          :countDownTime="count_down_time"
          :countDownDesc="count_down_desc"
          :superColor="true"
          @finish="countDownFinish"
        ></seckill-component>
      </div>
    </div>

    <div class="super-wrapper__bottom">
      <div class="super_content">
        <!-- 大促+秒杀 -->
        <template v-if="priceStatus == 1 || priceStatus == 2">
          <div class="left-info">
            <div class="cur">
              <p class="price">
                <span class="unit">&yen;</span>
                <span class="num">{{ handPriceVo.handPriceCent / 100 }}</span>
              </p>
            </div>
            <div class="equation">
              <div>
                <p class="tag tag1">=</p>
              </div>
              <div>
                <p class="text">原价</p>
                <p class="number"><em>&yen;</em>{{ handPriceVo.priceCent / 100 }}</p>
              </div>
              <div>
                <p class="tag">-</p>
              </div>
              <div>
                <p class="text">秒杀</p>
                <p class="number"><em>&yen;</em>{{ handPriceVo.promotionDownPriceCent / 100 }}</p>
              </div>
              <div v-if="handPriceVo.couponDownPriceCent > 0">
                <p class="tag">-</p>
              </div>
              <div v-if="handPriceVo.couponDownPriceCent > 0">
                <p class="text">红包</p>
                <p class="number"><em>&yen;</em>{{ handPriceVo.couponDownPriceCent / 100 }}</p>
              </div>
            </div>
          </div>
          <costPerformance
            class="seckill-cost"
            superColor
            :fineDiscount="fineDiscount"
            :costPerformanceText="costPerformanceText"
          />
        </template>
        <!-- 大促  | 十亿补贴-->
        <div v-if="priceStatus == 3 || (priceStatus == 0 && billionLevel)">
          <goods-price-component
            :superLevel="superLevel"
            :billionLevel="billionLevel"
            :handPriceVo="handPriceVo"
            :superColor="true"
            :costPerformanceText="costPerformanceText"
            :fineDiscount="fineDiscount"
            :actInfoVo="dataInfo.actInfoVo"
            :dataInfo="dataInfo"
          ></goods-price-component>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import seckillComponent from './seckill-component'

import goodsPriceComponent from './goods-price-component'
import costPerformance from './cost-performance'

export default defineComponent({
  components: {
    seckillComponent,
    costPerformance,
    goodsPriceComponent
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    countDownTime: {
      type: Number,
      default: 0
    },
    countDownDesc: {
      type: String,
      default: ''
    },
    priceStatus: {
      type: Number,
      default: 0
    },
    feedbackData: {
      type: Object,
      default: () => {}
    },

    superLevel: {
      type: Boolean,
      default: false
    },
    billionLevel: {
      type: Boolean,
      default: false
    },
    costPerformanceText: {
      type: String,
      default: ''
    },
    isVipMemeber: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const handPriceVo = computed(() => {
      return props.dataInfo.handPriceVo
    })
    const fineDiscount = computed(() => {
      if (handPriceVo.value.handPricePremiumContentNew) {
        return null
      }
      return props.dataInfo?.costPerformanceExplain?.priceTag
    })
    const count_down_time = computed(() => {
      return props.countDownTime || Number(props.dataInfo.couponLv.deadLine) || ''
    })
    const count_down_desc = computed(() => {
      const { desc = '' } = props.dataInfo?.couponLv || {}
      if (desc && !props.dataInfo?.actInfoVo) {
        return desc
      } else {
        return '距秒杀结束'
      }
    })
    const countDownFinish = () => {
      ctx.emit('finish')
    }
    return {
      fineDiscount,
      handPriceVo,
      countDownFinish,
      count_down_time,
      count_down_desc
    }
  }
})
</script>

<style lang="scss" scoped>
.super-wrapper {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0.5px;
  margin-bottom: 12px;
  padding: 0 24px;
  padding-bottom: 26px;
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 100% 100%;

  &__header {
    display: flex;
    justify-content: space-between;
    .text-wrapper {
      display: flex;
      align-items: center;
      margin-top: 16px;
      img {
        width: 15px;
        height: 22px;
        margin-right: 12px;
      }
      .title {
        position: relative;
        top: 2px;
        width: 200px;
        overflow: hidden;
        color: #ffffff;
        font-weight: 500;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        line-height: 24px;
        letter-spacing: 1px;
      }
    }
    .billion-text {
      position: relative;
      top: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 4px;
      color: #ff483c;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;

      .dot {
        display: flex;
        display: flex;
        align-items: center;
        align-items: center;
        justify-content: center;
        width: 10px;
        height: 22px;
        margin: 0 8px;

        img {
          width: 15px;
          height: 22px;
          margin-right: 12px;
        }
        .title {
          position: relative;
          top: 2px;
          width: 200px;
          overflow: hidden;
          color: #ffffff;
          font-weight: 500;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 24px;
          letter-spacing: 1px;
        }
      }

      .seckill {
        margin-top: 4px;
      }
    }
  }
  &__bottom {
    .super_content {
      display: flex;
      flex-direction: column;
      // align-items: center;
      // justify-content: space-between;

      .level {
        position: relative;
        top: 6px;
      }
      .left-info {
        display: flex;
        align-items: center;
        margin-top: 24px;
        margin-bottom: 18px;
        .cur {
          position: relative;
          top: 4px;
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #fff;
          font-weight: 500;
          font-size: 64px;
          font-family: Akrobat-ExtraBold;
          line-height: 56px;

          .price {
            display: flex;
            align-items: baseline;
            span {
              display: inline-block;
            }

            span.unit {
              color: #ffffff;
              font-weight: 800;
              font-size: 36px;
              font-family: Avenir-Heavy, Avenir;
              line-height: 26px;
            }
          }
        }
        .equation {
          display: flex;
          margin-top: 4px;
          margin-left: -8px;
          color: #fff;
          div {
            text-align: center;
          }
          .tag {
            display: flex;
            align-items: center;
            height: 100%;
            margin: 0 24px;
            font-weight: 500;
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            &.tag1 {
              margin: 0 30px;
            }
          }
          .text {
            margin-bottom: 6px;
            color: #ffffff;
            font-weight: 400;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            line-height: 20px;
          }
          .number {
            color: #ffffff;
            font-weight: 500;
            font-size: 26px;
            font-family: PingFangSC-Medium, PingFang SC;
            line-height: 22px;
            em {
              font-size: 20px;
            }
          }
        }
      }
    }

    /deep/ .seckill-cost {
      margin-top: 0;
      margin-bottom: 20px;
    }
  }
}
</style>
